<template>
  <div>
    <v-dialog v-if='session' v-model='session' width=500 persistent no-click-animation>
      <!-- This div may be placed anywhere with a media-ref for video -->
      <div ref='media'>MEDIA</div>




      <v-card>
        <v-card v-if="session.direction=='incoming'">
          <v-card-title>{{session.remoteIdentity.displayName}}</v-card-title>
        </v-card>
        <v-card-title>{{ numberCalling }}</v-card-title>
        <v-card-subtitle>
          <v-btn v-if="'Established' === session.state" @click="showNumPad = !showNumPad" icon x-large>
            <v-icon>mdi-dialpad</v-icon>
          </v-btn>
        </v-card-subtitle>
        <v-card-text v-if="'Established' === session.state && showNumPad">
          <v-card elevation="0" class="mx-15 px-5 py-0 my-0" outlined>
            <v-card-actions>
              <v-row>
                <v-col cols=4 v-for='n of ["1", "2", "3", "4", "5", "6", "7", "8", "9", "*", "0", "#"]' :key='n'>
                  <v-btn @click='$sip.dtmf(n)' fab elevation='0'>{{ n }}</v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-card-text>
        <v-card-text v-if="['Initial','Establishing'].includes(session.state)">
          <h3 v-if='isIncoming(session)'>Incoming call</h3>
          <h4 v-if='isIncoming(session)'>{{session.remoteIdentity.displayName}}</h4>
          <h4 v-if='isIncoming(session)'>{{session.remoteIdentity.uri.user}}</h4>
          <h3 v-else>Connecting your call</h3>
        </v-card-text>
        <v-card-actions>
          <v-btn 
            v-if='isIncoming(session) && session.state === "Initial"' 
            @click='$sip.answer()' 
            color="green"
            dark
            fab
            >
            <v-icon>
              mdi-phone
            </v-icon> 
          </v-btn>
          <v-btn 
            @click='$sip.bye()' 
            dark
            color="red" 
            fab>
              <v-icon>mdi-phone-hangup-outline</v-icon>
          </v-btn>
          <v-btn @click='$sip.vid()' color='blue' fab><v-icon>mdi-video</v-icon></v-btn>
          <v-btn 
            v-if="session.state == 'Established' && !session.isMuted" 
            @click='$sip.mute(true)' 
            color="brown" 
            dark
            fab>
              <v-icon>mdi-microphone</v-icon>
          </v-btn>
          <v-btn 
            v-if="session.state == 'Established' && session.isMuted" 
            @click='$sip.mute(false)' 
            color="brown" 
            dark
            fab>
              <v-icon>mdi-microphone-off</v-icon>
          </v-btn>
          <v-btn 
            v-if="session.state == 'Established' && !session.isHeld" 
            @click='$sip.hold(true)' 
            color="blue" 
            dark
            fab>
              <v-icon>mdi-drag-vertical-variant</v-icon>
          </v-btn>
          <v-btn 
            v-if="session.state == 'Established' && session.isHeld" 
            @click='$sip.hold(false)' 
            color="blue" 
            
            fab>
              <v-icon>mdi-drag-vertical-variant</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <transfer-menu></transfer-menu>

        </v-card-actions>
        <v-card-actions>
          <media-input-selector :session="session"></media-input-selector>
        </v-card-actions>
      </v-card>
      <v-snackbar
      v-model="snackbar"
      timeout="0"
      multi-line
      >
        <v-card color="rgb(0,0,0,0)" elevation="0">
          <v-card-actions class='ma-0 pa-0'>
            <v-btn 
              @click='$sip.bye()' 
              dark
              color="red" 
              fab>
                <v-icon>mdi-phone-hangup-outline</v-icon>
            </v-btn>
            <media-input-selector :session="session"></media-input-selector>
            <v-spacer></v-spacer>
            <v-card
            color="rgb(0,0,0,0)" elevation='0'>
              <v-container ma-0 pa-0>
                <v-row class="mb-1" no-gutters>
                  <v-col class='mr-1'>
                    <v-btn 
                      v-if="session.state == 'Established' && !session.isMuted" 
                      @click='$sip.mute(true)' 
                      color="teal" 
                      dark
                      fab
                      small>
                        <v-icon>mdi-microphone</v-icon>
                    </v-btn>
                    <v-btn 
                      v-if="session.state == 'Established' && session.isMuted" 
                      @click='$sip.mute(false)' 
                      color="teal" 
                      dark
                      fab
                      small>
                        <v-icon>mdi-microphone-off</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col>
                    <v-btn 
                      v-if="'Established' === session.state" 
                      @click="showNumPad = !showNumPad"
                      color="blue"
                      fab
                      small>
                      <v-icon>mdi-dialpad</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col class='mr-1'>
                    <v-btn 
                      v-if="session.state == 'Established' && !session.isHeld" 
                      @click='$sip.hold(true)' 
                      color="blue" 
                      dark
                      fab
                      small>
                        <v-icon>mdi-phone-paused</v-icon>
                    </v-btn>
                    <v-btn 
                      v-if="session.state == 'Established' && session.isHeld" 
                      @click='$sip.hold(false)' 
                      color="blue" 
                      fab
                      small>
                        <v-icon>mdi-phone-in-talk</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col>
                    <transfer-menu></transfer-menu>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-card-actions>
        </v-card>
      </v-snackbar>
    </v-dialog>
  </div>
</template>

<script >
import { mapState } from "vuex";
import { Invitation } from 'sip.js';
import MediaInputSelector from '../components/media-input-selector.vue';
import TransferMenu from '../components/TransferMenu.vue'

export default {
  data: () =>({
    snackbar: false,
    menu: false,
    transferNum: null,
    showNumPad: false,
  }),
  mounted() { this.attachMedia() },
  updated() { this.attachMedia() },
  computed: {
    ...mapState(["lineKeys"]),
    session: {
      get() { return this.$store.getters['sip/session'] },
    /*lineKeys: {
      get() {
        return this.$store.state.lineKeys;
      },
      set: function (v) {
        this.$store.commit("lineKeys", v);
      },
    },*/
    },
    numberCalling: {
      // This will show the number on the dialpad, but will not always match to the session
      // TODO: get this from the session instead.
      //
      // (will matter more when there are multiple sessions)
      get: function() { return this.$store.state.number; },
      set: function(v) { this.$store.commit('number',v)}
    },
    isDev: {
      get() { return process.env.NODE_ENV!=='production' }
    },
  },
  watch: {
    session() {
      this.attachMedia();
    }
  },
  components: {
    'media-input-selector': MediaInputSelector,
    'transfer-menu': TransferMenu,
    TransferMenu
  },
  methods: {
    logLineKeys(lk) {
      console.log(this.lineKeys)
      console.log('lineKeyId: ', lk.line_label)
    },
    isIncoming: it => it instanceof Invitation,
    attachMedia() {
      if (!this.$refs.media) throw new Error('media element not present in page');
      if (!this.session) return;
      if (!this.session.mediaElement) return;

      this.$refs.media.innerHTML = '';
      this.$refs.media.appendChild(this.session.mediaElement);
    },
    numberFromURI(uri) {
      return uri.toString().substring(4, 10);
    }
  }
};
</script>

<style scoped>
div[class*="col-"] {
  background: #fff;
  text-align: center;
  color: #000;
  border: 0px solid #ddd;
  padding: 5px;
}
.row {
  margin-bottom: 0px;
}
</style>
